import React from 'react';
import { Alert, Snackbar } from '@mui/material';

const ResultsTableSnackbar = ({ snackbar, onClose }) => (
  <Snackbar
    open={snackbar.open}
    autoHideDuration={3500}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  >
    <Alert onClose={onClose} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
      {snackbar.message}
    </Alert>
  </Snackbar>
);

export default ResultsTableSnackbar;
